import { useEffect, useState } from 'react'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import DocsHeader from './DocsHeader'
import DocsSidebar from './DocsSidebar'
import DocsTableOfContents from './DocsTableOfContents'
import Footer from '../Footer'
import './DocsLayout.css'

function DocsLayout() {
  const { t } = useTranslation()
  const location = useLocation()
  const { version = 'latest', lang = 'en' } = useParams()
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  useEffect(() => {
    // Collapse the mobile menu after navigation so content is immediately visible.
    setIsSidebarOpen(false)
  }, [location.pathname])

  return (
    <div className='docs-layout'>
      <DocsHeader version={version} lang={lang} />

      <div className='docs-container'>
        <button
          type='button'
          className='docs-sidebar-toggle'
          aria-expanded={isSidebarOpen}
          onClick={() => setIsSidebarOpen(prev => !prev)}
        >
          {t('nav.documentation')}
          <span className='docs-sidebar-toggle-icon' aria-hidden='true'>
            {isSidebarOpen ? '▲' : '▼'}
          </span>
        </button>

        <DocsSidebar version={version} lang={lang} isOpen={isSidebarOpen} onNavigate={() => setIsSidebarOpen(false)} />

        <main className='docs-content'>
          <article className='docs-article'>
            <Outlet />
          </article>
        </main>

        <aside className='docs-toc'>
          <DocsTableOfContents />
        </aside>
      </div>

      <Footer />
    </div>
  )
}

export default DocsLayout
